import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { DtDrawer, type DrawerControlProps } from '@root/shared/ui-kit'

import { reatomPortWalletsTabAtom } from '../../atoms/reatom-port-wallets'

import { PortWalletsDrawerExport } from './port-wallets-drawer-export'
import { PortWalletsDrawerHeader } from './port-wallets-drawer-header'
import { PortWalletsDrawerImport } from './port-wallets-drawer-import'
import { PortWalletsDrawerTabs } from './port-wallets-drawer-tabs'

import type { ClassNameProps } from '@root/shared/react'

type PortWalletsDrawerProps = {} & ClassNameProps & DrawerControlProps

export const PortWalletsDrawer: React.FC<PortWalletsDrawerProps> = ({
  className,
  open,
  onOpenChange,
}) => {
  const [tab, setTab] = useAtom(reatomPortWalletsTabAtom)

  return (
    <Root overlay className={className} open={open} onOpenChange={onOpenChange}>
      <PortWalletsDrawerHeader onOpenChange={onOpenChange} />
      <PortWalletsDrawerTabs tab={tab} setTab={setTab} />
      {tab === 'export' ? (
        <PortWalletsDrawerExport />
      ) : (
        <PortWalletsDrawerImport onClose={() => onOpenChange?.(false)} />
      )}
    </Root>
  )
}

const Root = styled(DtDrawer)`
  width: 380px;
  background: var(--background-1);
  align-items: start;

  display: grid;
  grid-template-rows: auto auto 1fr;
`
